
import { FC } from "react";
import { ArrowDownLeftFromCircle, ArrowUpRightFromCircle, Users, CircleDot } from "lucide-react";
import { useTranslation } from "react-i18next";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const IncomingIcon: FC<IconProps> = (props) => {
  return <ArrowDownLeftFromCircle {...props} />;
};

export const OutgoingIcon: FC<IconProps> = (props) => {
  return <ArrowUpRightFromCircle {...props} />;
};

export const EmploymentIcon: FC<IconProps> = (props) => {
  return <Users {...props} />;
};

export const CircleDotIcon: FC<IconProps> = (props) => {
  return <CircleDot {...props} />;
};

export const getDirectionIcon = (direction: string | undefined, className?: string) => {
  switch (direction) {
    case "incoming":
      return <IncomingIcon className={`${className || 'h-4 w-4'} text-emerald-500`} />;
    case "outgoing":
      return <OutgoingIcon className={`${className || 'h-4 w-4'} text-orange-500`} />;
    case "employment":
      return <EmploymentIcon className={`${className || 'h-4 w-4'} text-purple-500`} />;
    case "other":
    default:
      return <CircleDotIcon className={`${className || 'h-4 w-4'} text-blue-500`} />;
  }
};

export const DirectionText: FC<{ direction: string | undefined }> = ({ direction }) => {
  const { t } = useTranslation();
  
  return <>{getDirectionTextValue(direction, t)}</>;
};

export const getDirectionTextValue = (direction: string | undefined, t: any) => {
  switch (direction) {
    case "incoming":
      return t('contractDirection.incoming', "Incoming (receiving payment)");
    case "outgoing":
      return t('contractDirection.outgoing', "Outgoing (making payment)");
    case "employment":
      return t('contractDirection.employment', "Employment/Salary related");
    case "other":
    default:
      return t('contractDirection.other', "Other contract type");
  }
};

// This is a wrapper for backward compatibility
export const getDirectionText = (direction: string | undefined) => {
  const { t } = require('react-i18next').useTranslation();
  return getDirectionTextValue(direction, t);
};
